import { useMemo } from 'react';

import { RelatorioAprovacaoConfig, RelatorioAprovacaoSecao } from 'helper/Relatorios/Aprovacao/config';
import { useGetDessemOptionsQuery } from 'services/api/products/relatorios';
import { DessemSecaoInfo } from 'types/Relatorios/Dessem';

/**
 * Ordem e título do backend para os slugs que o FE conhece (`config`); slug do BE que o FE não
 * conhece é ignorado e slug do config ausente no BE vai ao fim, com o label do config. Sem lista
 * do BE devolve o config.
 */
export const mesclarSecoes = (
  config: RelatorioAprovacaoSecao[],
  doBackend?: DessemSecaoInfo[],
): RelatorioAprovacaoSecao[] => {
  if (!doBackend?.length) return config;
  const conhecidas = new Set(config.map((s) => s.slug));
  const doBe = doBackend
    .filter((s) => conhecidas.has(s.slug))
    .map((s) => ({ slug: s.slug as string, label: s.titulo }));
  const vistos = new Set(doBe.map((s) => s.slug));
  return [...doBe, ...config.filter((s) => !vistos.has(s.slug))];
};

/**
 * Abas do informe: ordem e título do `GET options` (só DESSEM tem o endpoint), com fallback em
 * `config.secoes`. Slug que o FE não conhece é ignorado, porque não há rota para ele. A
 * aprovação continua usando `config.secoes`. O arg `undefined` reaproveita o cache de
 * `useDessemMaxData`/`useDessemHidratacao`: não há request extra.
 */
export default function useSecoesDoInforme(
  config: RelatorioAprovacaoConfig,
): RelatorioAprovacaoSecao[] {
  const isDessem = config.informe === 'dessem';
  const { currentData } = useGetDessemOptionsQuery(undefined, { skip: !isDessem });
  return useMemo(
    () => mesclarSecoes(config.secoes, isDessem ? currentData?.secoes : undefined),
    [config.secoes, isDessem, currentData],
  );
}
